import { Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme: Theme) => ({
  container: {
    display: "flex",
    alignItems: "center",
  },
  formContainer: {
    width: 660,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
  },
  buttonContainer: {
    height: 52,
    flex: 1,
    display: "flex",
    flexDirection: "row-reverse",
    marginTop: 30,
    width: "100%",
  },
  apiKeyRow: {
    height: 86,
    backgroundColor: theme.palette.natural.t10,
    width: 660,
    marginTop: 24,
    display: "flex",
    alignItems: "center",
    borderRadius: 4,
  },
  title: {
    fontSize: 28,
    fontWeight: "bold",
    color: theme.palette.main.secondary.u1,
  },
  iconContainer: {
    height: 32,
    width: 32,
    borderRadius: 16,
    marginLeft: 16,
    marginRight: 16,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: theme.palette.main.accent.o,
  },
  statusContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    marginRight: 24,
    cursor: "pointer",
  },
  statusTitle: {
    fontWeight: "500",
    color: theme.palette.natural.t1,
    fontSize: 16,
  },
}));
